import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/case',
    name: 'projectcase',
    component: () => import(/* webpackChunkName: "about" */ '../views/ProjectCase.vue')
  },
  {
    path: '/custom',
    name: 'custom',
    component: () => import(/* webpackChunkName: "about" */ '../views/CustomDevelop.vue')
  },
  {
    path: '/problem',
    name: 'problem',
    component: () => import(/* webpackChunkName: "about" */ '../views/problemDetail.vue')
  },
  {
    path: '/news',
    name: 'newscenter',
    component: () => import(/* webpackChunkName: "about" */ '../views/NewsCenter.vue')
  },
  {
    path: '/newsdetail',
    name: 'newsdetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/newsDetail.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
